module.exports = __webpack_public_path__ + "static/media/case-norwegian-1.edb302c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case-norwegian-1.jpg
// module id = 82
// module chunks = 3